export enum EditViewType {
  NOTEBOOK = "notebook",
  GRAPH = "graph",
  APP = "app",
  DATA_APP = "data-app",
  RUN_STATS = "run-stats",
}

export const DEFAULT_VIEW: EditViewType = EditViewType.NOTEBOOK;
export const VIEW_SEPARATOR = ",";
